/*
 * Peter Beales Roses - Rose Guarantee claim form
 * ---------------------------------------------------------------------------
 * Populates the "which rose" dropdown from the customer's own order history
 * (rendered server-side as JSON in sections/rose-guarantee-claim.liquid), and
 * reveals a plain manual-entry field for anyone whose rose doesn't show up
 * (different order email, in-store purchase, gift, etc). No dependency on
 * the order data actually loading - the dropdown just has nothing but its
 * placeholder if the JSON is empty, and the manual field is always available.
 */
(function () {
  'use strict';

  function initRoseClaim() {
    document.querySelectorAll('[data-rc-rose-select]').forEach(function (select) {
      if (select.hasAttribute('data-rc-bound')) return;
      select.setAttribute('data-rc-bound', '');

      var root = select.closest('.rose-claim__field');
      var scriptTag = root && root.querySelector('[data-rc-roses]');
      var manualToggle = root && root.querySelector('[data-rc-manual-toggle]');
      var manualField = root && root.querySelector('[data-rc-manual-field]');
      var manualInput = manualField && manualField.querySelector('input');

      var roses = [];
      if (scriptTag) {
        try { roses = JSON.parse(scriptTag.textContent) || []; } catch (e) { roses = []; }
      }

      roses.forEach(function (r) {
        if (!r || !r.value) return;
        var opt = document.createElement('option');
        opt.value = r.value;
        opt.textContent = r.label || r.value;
        select.appendChild(opt);
      });

      // Always offer the manual fallback once JS has run, whether or not
      // any orders loaded - the customer decides if their rose is missing.
      if (manualToggle) {
        manualToggle.hidden = false;
        manualToggle.addEventListener('click', function () {
          var opening = manualField.hidden;
          manualField.hidden = !opening;
          manualToggle.textContent = opening
            ? 'I can see my rose in the list above instead'
            : "Can't find your rose here? Search for it manually";
          if (opening) {
            select.required = false;
            if (manualInput) { manualInput.required = true; manualInput.focus(); }
          } else {
            select.required = true;
            if (manualInput) { manualInput.required = false; manualInput.value = ''; }
          }
        });
      }

      // If there are no real orders to choose from, skip straight to manual
      // entry rather than making the customer discover the toggle themselves.
      if (!roses.length && manualToggle) {
        manualToggle.click();
      }
    });
  }

  initRoseClaim();
  window.pbInitRoseClaim = initRoseClaim;
})();
